export const actionTypes = {
    setFilterFields: "SET_FILTER_FIELDS",
    setFilterFieldValue: "SET_FILTER_FIELD_VALUE",
};
